export default "__VITE_ASSET__2739aacf__"